module.exports = __webpack_public_path__ + "img/1.fd7b280c.png";